import { App } from 'vue'
import FilterItemBoolean from './components/FilterControls/FilterItemComponents/FilterItemBoolean.vue'
import FilterItemDate from './components/FilterControls/FilterItemComponents/FilterItemDate.vue'
import FilterItemNumber from './components/FilterControls/FilterItemComponents/FilterItemNumber.vue'
import FilterItemSelect from './components/FilterControls/FilterItemComponents/FilterItemSelect.vue'
import FilterItemString from './components/FilterControls/FilterItemComponents/FilterItemString.vue'
import ModernFilterRule from './components/FilterControls/ModernFilterComponents/ModernFilterRule.vue'
import ModernFilterWrapper from './components/FilterControls/ModernFilterComponents/ModernFilterWrapper.vue'
import FilterResultDisplayContainer from './components/FilterResultDisplayContainer.vue'
import DataListFilterItemModelColumnInput from './components/DataListQueryControls/DataListFilterItemModelColumnInput.vue'

export const registerFilterItemComponents = (Vue: App) => {
  Vue.component('FilterItemBoolean', FilterItemBoolean)
  Vue.component('FilterItemDate', FilterItemDate)
  Vue.component('FilterItemNumber', FilterItemNumber)
  Vue.component('FilterItemString', FilterItemString)
  Vue.component('FilterItemSelect', FilterItemSelect)
  Vue.component('ModernFilterRule', ModernFilterRule)
  Vue.component('ModernFilterWrapper', ModernFilterWrapper)
  Vue.component('FilterResultDisplayContainer', FilterResultDisplayContainer)
  Vue.component('DataListFilterItemModelColumnInput', DataListFilterItemModelColumnInput)
}
